import { render } from "./ProgrammeBanner.vue?vue&type=template&id=fe66f8ee&scoped=true"
import script from "./ProgrammeBanner.vue?vue&type=script&lang=js"
export * from "./ProgrammeBanner.vue?vue&type=script&lang=js"

import "./ProgrammeBanner.vue?vue&type=style&index=0&id=fe66f8ee&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe66f8ee"]])

export default __exports__